import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import image from "../../assets/not-found.png";
import Button from "../../components/atoms/Button";
import { updateUsers } from "../../service/auth";

function NotFound() {

    const {user} = useSelector(state => state.auth);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/factory");
    }

    const handleUpdate = async () => {
        const data = await updateUsers();

        console.log(data);
    }

    return (
        <div className="not-found">
            <img src={image} alt="Not Found" />
            <div className="not-found-text">Sayfa Bulunamadı!</div>
            <Button title={'Ana Sayfaya Dön'} className='primary-btn' onClick={handleClick} />
            {
                user.role === 'superadmin' && 
                <Button title={'Update users'} className='primary-btn' onClick={handleUpdate} />
            }
        </div>
    );
}

export default NotFound;
